import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import { TransferList, ZaddonsCircularProgress } from '@commonClient2/components';
import { getImportScheduleStepsLabel } from '../../../../Enums/Helpers/LabellingHelper';

/**
 * @param {{
 *  items: ManagerAppData.IWorkplanBrief[];
 *  handleChange: function;
 *  handleRetrieveSchedulePatternsClick: function;
 *  handleItemToggle: function | undefined;
 *  isRetrieveButtonDisabled: boolean;
 *  workplanSelectionDisabled: boolean;
 *  isUploadingSchedule: boolean;
 *  uploadScheduleProgressValue?: number;
 *  uploadScheduleStepCode?: ImportScheduleSteps;
 *  hasOnlyViewAccess?: boolean;
 * }} props
 */
function WorkplanSelection(props) {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'form.scheduleSelection.workplan' });

    const {
        items,
        handleChange,
        handleRetrieveSchedulePatternsClick,
        handleItemToggle = () => { },
        isRetrieveButtonDisabled,
        workplanSelectionDisabled,
        isUploadingSchedule,
        uploadScheduleProgressValue,
        uploadScheduleStepCode,
        hasOnlyViewAccess
    } = props;

    if (hasOnlyViewAccess) {
        return <></>;
    }

    return (
        <div>
            <TransferList
                items={items}
                width={500}
                onChange={(
                    /** @type {import('@commonClient2/../typings/transferList').TransferListItem[]} */transferListResult,
                ) => handleChange(transferListResult)}
                onItemToggle={handleItemToggle}
                titleLeft={t('available')}
                titleRight={t('selected')}
                useSearchBars={false}
                useSelectAll={false}
                useTotalLeft={false}
                useTotalRight={false}
                // @ts-ignore
                disabled={workplanSelectionDisabled || isUploadingSchedule}
            />
            <div className="workplan-selection-apply-button">
                <Button
                    disabled={workplanSelectionDisabled || isRetrieveButtonDisabled || isUploadingSchedule}
                    color="primary"
                    variant="contained"
                    onClick={() => handleRetrieveSchedulePatternsClick()}
                >
                    {isUploadingSchedule
                        ? (
                            <>
                                <ZaddonsCircularProgress
                                    size={25}
                                    value={uploadScheduleProgressValue}
                                    // @ts-ignore
                                    label={getImportScheduleStepsLabel(uploadScheduleStepCode)}
                                />
                            </>
                        ) : t('retrieve')}
                </Button>
            </div>
        </div>
    );
}

export default WorkplanSelection;
